const START_CHUNK_SIZE = 8 * 1024 * 1024;
const START_MULTIPART_SIZE = START_CHUNK_SIZE * 2;
const MAX_CHUNK_SIZE = 5 * 1024 * 1024 * 1024;
const MAX_PARTS = 900;
const CHUNK_MULT = 64;

exports.calcChunkSize = calcChunkSize;
exports.START_MULTIPART_SIZE = START_MULTIPART_SIZE;

function calcChunkSize(size) {
  let chunk_size;
  if (size < START_MULTIPART_SIZE) {
    chunk_size = START_MULTIPART_SIZE;
  } else {
    chunk_size = START_CHUNK_SIZE;

    while (size > chunk_size * MAX_PARTS) {
      chunk_size *= CHUNK_MULT;
      if (chunk_size > MAX_CHUNK_SIZE) {
        chunk_size = MAX_CHUNK_SIZE;
        break;
      }
    }
  }
  return chunk_size;
}
